import type { ThresholdStatus } from "@/lib/nutritionEngine";

const STATUS_COLOR: Record<ThresholdStatus, string> = {
  below: "bg-clay-500",
  "on-track": "bg-forest-500",
  above: "bg-amber-500",
};

export default function NutrientBar({
  label,
  value,
  target,
  unit,
  status,
}: {
  label: string;
  value: number;
  target: number;
  unit: string;
  status: ThresholdStatus;
}) {
  const pct = Math.min(100, target > 0 ? (value / target) * 100 : 0);
  return (
    <div className="py-2">
      <div className="mb-1 flex items-baseline justify-between text-sm">
        <span className="font-medium text-ink">{label}</span>
        <span className="text-forest-500">
          {Math.round(value)} / {Math.round(target)} {unit}
        </span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-pill bg-line">
        <div
          className={`h-full rounded-pill ${STATUS_COLOR[status]}`}
          style={{ width: `${pct}%`, transition: "width 0.4s ease" }}
        />
      </div>
    </div>
  );
}
